// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPerformanceHistoryDto
 */
export interface IPerformanceHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof IPerformanceHistoryDto
     */
    account_balance?: number;
    /**
     * 
     * @type {Date}
     * @memberof IPerformanceHistoryDto
     */
    performance_date?: Date;
}

/**
 * Check if a given object implements the IPerformanceHistoryDto interface.
 */
export function instanceOfIPerformanceHistoryDto(value: object): value is IPerformanceHistoryDto {
    return true;
}

export function IPerformanceHistoryDtoFromJSON(json: any): IPerformanceHistoryDto {
    return IPerformanceHistoryDtoFromJSONTyped(json, false);
}

export function IPerformanceHistoryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPerformanceHistoryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_balance': json['account_balance'] == null ? undefined : json['account_balance'],
        'performance_date': json['performance_date'] == null ? undefined : (new Date(json['performance_date'])),
    };
}

export function IPerformanceHistoryDtoToJSON(json: any): IPerformanceHistoryDto {
    return IPerformanceHistoryDtoToJSONTyped(json, false);
}

export function IPerformanceHistoryDtoToJSONTyped(value?: IPerformanceHistoryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_balance': value['account_balance'],
        'performance_date': value['performance_date'] == null ? undefined : ((value['performance_date']).toISOString().substring(0,10)),
    };
}

